import { ProductForDropdownModel } from '@alcon-db-models/ProductForDropdownModel';
import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { productsForDropdown } from '@app-store/app-session/app-session.selectors';
import { Store } from '@ngrx/store';
import { CommitmentEditService } from '@services/commitment-edit.service';
import { CommitmentFormBaseService } from '@services/commitment-form-base.service';
import { Subject, Subscription } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { EditCommitmentProductsComponent } from './edit-commitment-products.component';

@Component({
  selector: 'acb-alcon-edit-commitment-products-dialog',
  template: `
    <kendo-dialog-titlebar class="acb-edit-commitment-products-titlebar" (close)="onClose()">
      Edit Products
    </kendo-dialog-titlebar>
    <ng-container #editCommitmentProductsContainer></ng-container>
    <kendo-dialog-actions>
      <button kendoButton class="acb-cancel" (click)="onCancel()"><span class="k-icon k-i-cancel"></span>Cancel</button>
      <button kendoButton [primary]="true" (click)="onApply()" [disabled]="!valid" ><span class="k-icon k-i-checkmark"></span>Apply</button>
    </kendo-dialog-actions>
  `,
  styleUrls: ['./edit-commitment-products-dialog.component.scss']
})
export class EditCommitmentProductsDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('editCommitmentProductsContainer', { read:ViewContainerRef }) editCommitmentProductsContainer?: ViewContainerRef;

  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() apply: EventEmitter<any> = new EventEmitter();

  private _commitmentEditServiceSubscription?:Subscription;
  private _commitmentEditService?: CommitmentEditService;
  public set commitmentEditService(value:CommitmentEditService) {
    this._commitmentEditService = value;
    this._commitmentEditServiceSubscription?.unsubscribe();
    this._commitmentEditServiceSubscription = this._commitmentEditService.validityChange$.pipe(takeUntil(this._destroy$)).subscribe(x => {
      this.valid = x.products;
      this.changeDetectionRef.detectChanges();
    });
  }

  public valid: boolean = true;

  private _productsForDropdown: ProductForDropdownModel[] = [];
  private _destroy$: Subject<void> = new Subject<void>();

  constructor(
    store:Store,
    private resolver: ComponentFactoryResolver,
    private changeDetectionRef : ChangeDetectorRef
    ) {
    store.select(productsForDropdown).pipe(first()).subscribe(x => { this._productsForDropdown = x });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Need to pass service to edit details component, provider context is lost going through window service...
    // TODO: Clean up by moving to feature NGRX?
    if (this.editCommitmentProductsContainer && this._commitmentEditService) {
      const factory = this.resolver.resolveComponentFactory(EditCommitmentProductsComponent);

      const injector: Injector = Injector.create({ providers: [{ provide: CommitmentFormBaseService, useValue: this._commitmentEditService }]});
      injector.get(CommitmentFormBaseService);

      const ref: ComponentRef<EditCommitmentProductsComponent> =  this.editCommitmentProductsContainer.createComponent(factory, undefined, injector);
      ref.instance.doShowLegend = false;

      this.changeDetectionRef.detectChanges();
    }
  }

  public onCancel() {
    this.cancel.emit(null);
  }

  public onApply() {
    if (this.valid)
      this.apply.emit(null);
  }

  public onClose() {
    this.cancel.emit(null);
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
